import styled from 'styled-components';

export const Wrapper = styled.aside`
  display: flex;
  position: relative;
  width: 94px;
  height: 100vh;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  background: ${({ theme }) => theme.color.menu};
  transition: width 0.3s ease-in-out;
  padding-top: 24px;

  &::-webkit-scrollbar {
    display: none;
  }

  .accordion-root {
    color: ${({ theme }) => theme.color.white};

    &.active {
      background: ${({ theme }) => theme.color.green100};
      color: ${({ theme }) => theme.color.menu};
      & .accordion-title {
        color: ${({ theme }) => theme.color.menu};
        > svg {
          path {
            fill: ${({ theme }) => theme.color.menu};
          }
        }
      }
    }
  }

  .accordion-list {
    button.active {
      background: transparent;
      color: ${({ theme }) => theme.color.white};
    }
  }

  > hr {
    margin: 16px 0;
    width: 100%;
    background-color: ${({ theme }) => theme.color.navigator};
  }

  .logo-text {
    height: 44px;
    position: absolute;
    visibility: hidden;
    padding: 0 16px;
    opacity: 0;
    transition: visibility 0s, opacity 1s linear;
  }

  .logo {
    width: 44px;
    height: 44px;
    visibility: visible;
    opacity: 1;
    position: relative;
    transition: visibility 0s, opacity 1s linear;
  }

  .item-list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    margin-top: 8px;
  }

  .language {
    padding: 4px 12px;
    display: flex;
    align-items: center;
    margin-top: 16px;
    gap: 8px;

    > p,
    span {
      cursor: pointer;
      font-size: 12px;
      line-height: 16.8px;
      font-weight: 700;
      letter-spacing: 0.08px;
      border-radius: 4px;
      height: 100%;
      padding: 7px 0;
      transition: padding 0.3s linear;
      :hover {
        background: ${({ theme }) => theme.color.navigatorHover};
      }
    }

    > span {
      color: ${({ theme }) => theme.color.grey400};
      font-weight: 700;

      &.active {
        color: ${({ theme }) => theme.color.white};
      }
    }
  }

  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    cursor: pointer;
    border-radius: 4px;
    height: fit-content;
    color: ${({ theme }) => theme.color.white};

    > svg {
      height: 24px;
      width: 24px;
    }

    :hover {
      background: ${({ theme }) => theme.color.navigatorHover};
    }

    > span {
      height: 22px;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0.08px;
      display: none;
      overflow: hidden;
    }
  }

  &.active {
    width: 312px;
    .logo {
      visibility: hidden;
      opacity: 0;
    }
    .logo-text {
      visibility: visible;
      opacity: 1;
    }

    .language {
      margin-left: 0px;
      > svg {
        margin-right: 1px;
      }
      > p,
      span {
        padding: 7px;
      }
      > span,
      hr {
        visibility: visible;
        opacity: 1;
        transition: visibility 0s, opacity 0.3s linear;
      }
    }

    .logout {
      > span {
        display: block;
      }
    }
    .accordion-root {
      &.active {
        background: transparent;
        & .accordion-title {
          color: ${({ theme }) => theme.color.white};
          > svg {
            path {
              fill: ${({ theme }) => theme.color.white};
            }
          }
        }
      }
      :hover {
        background: ${({ theme }) => theme.color.navigatorHover};
      }
    }

    .accordion-list {
      button.active {
        background: ${({ theme }) => theme.color.green100};
        color: ${({ theme }) => theme.color.menu};
      }
    }
    .accordion-expand {
      > svg {
        visibility: visible;
        opacity: 1;
        transition: visibility 0s, opacity 0.3s linear;
      }
    }
    .accordion-info {
      .image {
        left: unset;
      }
    }
  }
`;

export const Box = styled.div`
  position: relative;
  height: fit-content;
  width: 100%;
  height: 44px;
  margin-bottom: 24px;

  &.expanded {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > button {
      position: absolute;
      margin-bottom: 0;
      right: 0;
    }
  }
`;

export const ButtonStyled = styled.button`
  all: unset;
  cursor: pointer;
  margin-bottom: 24px;
  svg {
    width: 44px;
    height: 44px;
  }

  &:hover {
    svg {
      path {
        stroke: ${({ theme }) => theme.color.blue300};
      }
    }
  }
`;
